import et, { createContext as Yt, useState as _e, useCallback as ie, useContext as tt, useEffect as se, useRef as qt } from "react";
import { Button as xe, Text as Vt, Link as Bt } from "@beamery/lib-ds-components";
import ue, { createGlobalStyle as Kt } from "styled-components";
import "@beamery/lib-ds-theme";
function Jt(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var we = { exports: {} }, K = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xe;
function Gt() {
  if (Xe)
    return K;
  Xe = 1;
  var e = et, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, c, d) {
    var g, w = {}, T = null, L = null;
    d !== void 0 && (T = "" + d), c.key !== void 0 && (T = "" + c.key), c.ref !== void 0 && (L = c.ref);
    for (g in c)
      n.call(c, g) && !i.hasOwnProperty(g) && (w[g] = c[g]);
    if (l && l.defaultProps)
      for (g in c = l.defaultProps, c)
        w[g] === void 0 && (w[g] = c[g]);
    return { $$typeof: t, type: l, key: T, ref: L, props: w, _owner: a.current };
  }
  return K.Fragment = r, K.jsx = s, K.jsxs = s, K;
}
var J = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Qe;
function Ht() {
  return Qe || (Qe = 1, process.env.NODE_ENV !== "production" && function() {
    var e = et, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), g = Symbol.for("react.suspense_list"), w = Symbol.for("react.memo"), T = Symbol.for("react.lazy"), L = Symbol.for("react.offscreen"), Q = Symbol.iterator, Z = "@@iterator";
    function $(o) {
      if (o === null || typeof o != "object")
        return null;
      var u = Q && o[Q] || o[Z];
      return typeof u == "function" ? u : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function R(o) {
      {
        for (var u = arguments.length, f = new Array(u > 1 ? u - 1 : 0), p = 1; p < u; p++)
          f[p - 1] = arguments[p];
        ut("error", o, f);
      }
    }
    function ut(o, u, f) {
      {
        var p = x.ReactDebugCurrentFrame, m = p.getStackAddendum();
        m !== "" && (u += "%s", f = f.concat([m]));
        var y = f.map(function(b) {
          return String(b);
        });
        y.unshift("Warning: " + u), Function.prototype.apply.call(console[o], console, y);
      }
    }
    var ft = !1, ht = !1, dt = !1, pt = !1, gt = !1, Se;
    Se = Symbol.for("react.module.reference");
    function vt(o) {
      return !!(typeof o == "string" || typeof o == "function" || o === n || o === i || gt || o === a || o === d || o === g || pt || o === L || ft || ht || dt || typeof o == "object" && o !== null && (o.$$typeof === T || o.$$typeof === w || o.$$typeof === s || o.$$typeof === l || o.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      o.$$typeof === Se || o.getModuleId !== void 0));
    }
    function bt(o, u, f) {
      var p = o.displayName;
      if (p)
        return p;
      var m = u.displayName || u.name || "";
      return m !== "" ? f + "(" + m + ")" : f;
    }
    function Ce(o) {
      return o.displayName || "Context";
    }
    function A(o) {
      if (o == null)
        return null;
      if (typeof o.tag == "number" && R("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof o == "function")
        return o.displayName || o.name || null;
      if (typeof o == "string")
        return o;
      switch (o) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case d:
          return "Suspense";
        case g:
          return "SuspenseList";
      }
      if (typeof o == "object")
        switch (o.$$typeof) {
          case l:
            var u = o;
            return Ce(u) + ".Consumer";
          case s:
            var f = o;
            return Ce(f._context) + ".Provider";
          case c:
            return bt(o, o.render, "ForwardRef");
          case w:
            var p = o.displayName || null;
            return p !== null ? p : A(o.type) || "Memo";
          case T: {
            var m = o, y = m._payload, b = m._init;
            try {
              return A(b(y));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var z = Object.assign, V = 0, Me, Te, Fe, Pe, $e, je, Ae;
    function De() {
    }
    De.__reactDisabledLog = !0;
    function mt() {
      {
        if (V === 0) {
          Me = console.log, Te = console.info, Fe = console.warn, Pe = console.error, $e = console.group, je = console.groupCollapsed, Ae = console.groupEnd;
          var o = {
            configurable: !0,
            enumerable: !0,
            value: De,
            writable: !0
          };
          Object.defineProperties(console, {
            info: o,
            log: o,
            warn: o,
            error: o,
            group: o,
            groupCollapsed: o,
            groupEnd: o
          });
        }
        V++;
      }
    }
    function yt() {
      {
        if (V--, V === 0) {
          var o = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: z({}, o, {
              value: Me
            }),
            info: z({}, o, {
              value: Te
            }),
            warn: z({}, o, {
              value: Fe
            }),
            error: z({}, o, {
              value: Pe
            }),
            group: z({}, o, {
              value: $e
            }),
            groupCollapsed: z({}, o, {
              value: je
            }),
            groupEnd: z({}, o, {
              value: Ae
            })
          });
        }
        V < 0 && R("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var fe = x.ReactCurrentDispatcher, he;
    function ee(o, u, f) {
      {
        if (he === void 0)
          try {
            throw Error();
          } catch (m) {
            var p = m.stack.trim().match(/\n( *(at )?)/);
            he = p && p[1] || "";
          }
        return `
` + he + o;
      }
    }
    var de = !1, te;
    {
      var xt = typeof WeakMap == "function" ? WeakMap : Map;
      te = new xt();
    }
    function Ne(o, u) {
      if (!o || de)
        return "";
      {
        var f = te.get(o);
        if (f !== void 0)
          return f;
      }
      var p;
      de = !0;
      var m = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var y;
      y = fe.current, fe.current = null, mt();
      try {
        if (u) {
          var b = function() {
            throw Error();
          };
          if (Object.defineProperty(b.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(b, []);
            } catch (D) {
              p = D;
            }
            Reflect.construct(o, [], b);
          } else {
            try {
              b.call();
            } catch (D) {
              p = D;
            }
            o.call(b.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (D) {
            p = D;
          }
          o();
        }
      } catch (D) {
        if (D && p && typeof D.stack == "string") {
          for (var v = D.stack.split(`
`), M = p.stack.split(`
`), E = v.length - 1, _ = M.length - 1; E >= 1 && _ >= 0 && v[E] !== M[_]; )
            _--;
          for (; E >= 1 && _ >= 0; E--, _--)
            if (v[E] !== M[_]) {
              if (E !== 1 || _ !== 1)
                do
                  if (E--, _--, _ < 0 || v[E] !== M[_]) {
                    var j = `
` + v[E].replace(" at new ", " at ");
                    return o.displayName && j.includes("<anonymous>") && (j = j.replace("<anonymous>", o.displayName)), typeof o == "function" && te.set(o, j), j;
                  }
                while (E >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        de = !1, fe.current = y, yt(), Error.prepareStackTrace = m;
      }
      var U = o ? o.displayName || o.name : "", He = U ? ee(U) : "";
      return typeof o == "function" && te.set(o, He), He;
    }
    function wt(o, u, f) {
      return Ne(o, !1);
    }
    function kt(o) {
      var u = o.prototype;
      return !!(u && u.isReactComponent);
    }
    function re(o, u, f) {
      if (o == null)
        return "";
      if (typeof o == "function")
        return Ne(o, kt(o));
      if (typeof o == "string")
        return ee(o);
      switch (o) {
        case d:
          return ee("Suspense");
        case g:
          return ee("SuspenseList");
      }
      if (typeof o == "object")
        switch (o.$$typeof) {
          case c:
            return wt(o.render);
          case w:
            return re(o.type, u, f);
          case T: {
            var p = o, m = p._payload, y = p._init;
            try {
              return re(y(m), u, f);
            } catch {
            }
          }
        }
      return "";
    }
    var ne = Object.prototype.hasOwnProperty, ze = {}, Ie = x.ReactDebugCurrentFrame;
    function ae(o) {
      if (o) {
        var u = o._owner, f = re(o.type, o._source, u ? u.type : null);
        Ie.setExtraStackFrame(f);
      } else
        Ie.setExtraStackFrame(null);
    }
    function Et(o, u, f, p, m) {
      {
        var y = Function.call.bind(ne);
        for (var b in o)
          if (y(o, b)) {
            var v = void 0;
            try {
              if (typeof o[b] != "function") {
                var M = Error((p || "React class") + ": " + f + " type `" + b + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[b] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw M.name = "Invariant Violation", M;
              }
              v = o[b](u, b, p, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (E) {
              v = E;
            }
            v && !(v instanceof Error) && (ae(m), R("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", p || "React class", f, b, typeof v), ae(null)), v instanceof Error && !(v.message in ze) && (ze[v.message] = !0, ae(m), R("Failed %s type: %s", f, v.message), ae(null));
          }
      }
    }
    var Rt = Array.isArray;
    function pe(o) {
      return Rt(o);
    }
    function _t(o) {
      {
        var u = typeof Symbol == "function" && Symbol.toStringTag, f = u && o[Symbol.toStringTag] || o.constructor.name || "Object";
        return f;
      }
    }
    function Ot(o) {
      try {
        return Le(o), !1;
      } catch {
        return !0;
      }
    }
    function Le(o) {
      return "" + o;
    }
    function We(o) {
      if (Ot(o))
        return R("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", _t(o)), Le(o);
    }
    var B = x.ReactCurrentOwner, St = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ue, Ye, ge;
    ge = {};
    function Ct(o) {
      if (ne.call(o, "ref")) {
        var u = Object.getOwnPropertyDescriptor(o, "ref").get;
        if (u && u.isReactWarning)
          return !1;
      }
      return o.ref !== void 0;
    }
    function Mt(o) {
      if (ne.call(o, "key")) {
        var u = Object.getOwnPropertyDescriptor(o, "key").get;
        if (u && u.isReactWarning)
          return !1;
      }
      return o.key !== void 0;
    }
    function Tt(o, u) {
      if (typeof o.ref == "string" && B.current && u && B.current.stateNode !== u) {
        var f = A(B.current.type);
        ge[f] || (R('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', A(B.current.type), o.ref), ge[f] = !0);
      }
    }
    function Ft(o, u) {
      {
        var f = function() {
          Ue || (Ue = !0, R("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", u));
        };
        f.isReactWarning = !0, Object.defineProperty(o, "key", {
          get: f,
          configurable: !0
        });
      }
    }
    function Pt(o, u) {
      {
        var f = function() {
          Ye || (Ye = !0, R("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", u));
        };
        f.isReactWarning = !0, Object.defineProperty(o, "ref", {
          get: f,
          configurable: !0
        });
      }
    }
    var $t = function(o, u, f, p, m, y, b) {
      var v = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: o,
        key: u,
        ref: f,
        props: b,
        // Record the component responsible for creating this element.
        _owner: y
      };
      return v._store = {}, Object.defineProperty(v._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(v, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: p
      }), Object.defineProperty(v, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: m
      }), Object.freeze && (Object.freeze(v.props), Object.freeze(v)), v;
    };
    function jt(o, u, f, p, m) {
      {
        var y, b = {}, v = null, M = null;
        f !== void 0 && (We(f), v = "" + f), Mt(u) && (We(u.key), v = "" + u.key), Ct(u) && (M = u.ref, Tt(u, m));
        for (y in u)
          ne.call(u, y) && !St.hasOwnProperty(y) && (b[y] = u[y]);
        if (o && o.defaultProps) {
          var E = o.defaultProps;
          for (y in E)
            b[y] === void 0 && (b[y] = E[y]);
        }
        if (v || M) {
          var _ = typeof o == "function" ? o.displayName || o.name || "Unknown" : o;
          v && Ft(b, _), M && Pt(b, _);
        }
        return $t(o, v, M, m, p, B.current, b);
      }
    }
    var ve = x.ReactCurrentOwner, qe = x.ReactDebugCurrentFrame;
    function W(o) {
      if (o) {
        var u = o._owner, f = re(o.type, o._source, u ? u.type : null);
        qe.setExtraStackFrame(f);
      } else
        qe.setExtraStackFrame(null);
    }
    var be;
    be = !1;
    function me(o) {
      return typeof o == "object" && o !== null && o.$$typeof === t;
    }
    function Ve() {
      {
        if (ve.current) {
          var o = A(ve.current.type);
          if (o)
            return `

Check the render method of \`` + o + "`.";
        }
        return "";
      }
    }
    function At(o) {
      {
        if (o !== void 0) {
          var u = o.fileName.replace(/^.*[\\\/]/, ""), f = o.lineNumber;
          return `

Check your code at ` + u + ":" + f + ".";
        }
        return "";
      }
    }
    var Be = {};
    function Dt(o) {
      {
        var u = Ve();
        if (!u) {
          var f = typeof o == "string" ? o : o.displayName || o.name;
          f && (u = `

Check the top-level render call using <` + f + ">.");
        }
        return u;
      }
    }
    function Ke(o, u) {
      {
        if (!o._store || o._store.validated || o.key != null)
          return;
        o._store.validated = !0;
        var f = Dt(u);
        if (Be[f])
          return;
        Be[f] = !0;
        var p = "";
        o && o._owner && o._owner !== ve.current && (p = " It was passed a child from " + A(o._owner.type) + "."), W(o), R('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', f, p), W(null);
      }
    }
    function Je(o, u) {
      {
        if (typeof o != "object")
          return;
        if (pe(o))
          for (var f = 0; f < o.length; f++) {
            var p = o[f];
            me(p) && Ke(p, u);
          }
        else if (me(o))
          o._store && (o._store.validated = !0);
        else if (o) {
          var m = $(o);
          if (typeof m == "function" && m !== o.entries)
            for (var y = m.call(o), b; !(b = y.next()).done; )
              me(b.value) && Ke(b.value, u);
        }
      }
    }
    function Nt(o) {
      {
        var u = o.type;
        if (u == null || typeof u == "string")
          return;
        var f;
        if (typeof u == "function")
          f = u.propTypes;
        else if (typeof u == "object" && (u.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        u.$$typeof === w))
          f = u.propTypes;
        else
          return;
        if (f) {
          var p = A(u);
          Et(f, o.props, "prop", p, o);
        } else if (u.PropTypes !== void 0 && !be) {
          be = !0;
          var m = A(u);
          R("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", m || "Unknown");
        }
        typeof u.getDefaultProps == "function" && !u.getDefaultProps.isReactClassApproved && R("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function zt(o) {
      {
        for (var u = Object.keys(o.props), f = 0; f < u.length; f++) {
          var p = u[f];
          if (p !== "children" && p !== "key") {
            W(o), R("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", p), W(null);
            break;
          }
        }
        o.ref !== null && (W(o), R("Invalid attribute `ref` supplied to `React.Fragment`."), W(null));
      }
    }
    function Ge(o, u, f, p, m, y) {
      {
        var b = vt(o);
        if (!b) {
          var v = "";
          (o === void 0 || typeof o == "object" && o !== null && Object.keys(o).length === 0) && (v += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var M = At(m);
          M ? v += M : v += Ve();
          var E;
          o === null ? E = "null" : pe(o) ? E = "array" : o !== void 0 && o.$$typeof === t ? (E = "<" + (A(o.type) || "Unknown") + " />", v = " Did you accidentally export a JSX literal instead of a component?") : E = typeof o, R("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", E, v);
        }
        var _ = jt(o, u, f, m, y);
        if (_ == null)
          return _;
        if (b) {
          var j = u.children;
          if (j !== void 0)
            if (p)
              if (pe(j)) {
                for (var U = 0; U < j.length; U++)
                  Je(j[U], o);
                Object.freeze && Object.freeze(j);
              } else
                R("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Je(j, o);
        }
        return o === n ? zt(_) : Nt(_), _;
      }
    }
    function It(o, u, f) {
      return Ge(o, u, f, !0);
    }
    function Lt(o, u, f) {
      return Ge(o, u, f, !1);
    }
    var Wt = Lt, Ut = It;
    J.Fragment = n, J.jsx = Wt, J.jsxs = Ut;
  }()), J;
}
process.env.NODE_ENV === "production" ? we.exports = Gt() : we.exports = Ht();
var S = we.exports;
const Oe = Yt({ isSidebarOpen: !1 });
function Tr({ logo: e, items: t, companyName: r, children: n }) {
  const [a, i] = _e(!1), s = ie(() => {
    i((c) => !c);
  }, []), l = ie(() => {
    i(!1);
  }, []);
  return /* @__PURE__ */ S.jsx(
    Oe.Provider,
    {
      value: {
        logo: e,
        items: t,
        companyName: r,
        isSidebarOpen: a,
        handleCloseSidebar: l,
        handleToggleSidebar: s
      },
      children: n
    }
  );
}
const I = {
  minimum: "320px",
  mobile: "640px",
  tablet: "768px",
  desktop: "925px",
  largeDesktop: "1800px"
};
var rt = { exports: {} }, nt = {
  aliceblue: [240, 248, 255],
  antiquewhite: [250, 235, 215],
  aqua: [0, 255, 255],
  aquamarine: [127, 255, 212],
  azure: [240, 255, 255],
  beige: [245, 245, 220],
  bisque: [255, 228, 196],
  black: [0, 0, 0],
  blanchedalmond: [255, 235, 205],
  blue: [0, 0, 255],
  blueviolet: [138, 43, 226],
  brown: [165, 42, 42],
  burlywood: [222, 184, 135],
  cadetblue: [95, 158, 160],
  chartreuse: [127, 255, 0],
  chocolate: [210, 105, 30],
  coral: [255, 127, 80],
  cornflowerblue: [100, 149, 237],
  cornsilk: [255, 248, 220],
  crimson: [220, 20, 60],
  cyan: [0, 255, 255],
  darkblue: [0, 0, 139],
  darkcyan: [0, 139, 139],
  darkgoldenrod: [184, 134, 11],
  darkgray: [169, 169, 169],
  darkgreen: [0, 100, 0],
  darkgrey: [169, 169, 169],
  darkkhaki: [189, 183, 107],
  darkmagenta: [139, 0, 139],
  darkolivegreen: [85, 107, 47],
  darkorange: [255, 140, 0],
  darkorchid: [153, 50, 204],
  darkred: [139, 0, 0],
  darksalmon: [233, 150, 122],
  darkseagreen: [143, 188, 143],
  darkslateblue: [72, 61, 139],
  darkslategray: [47, 79, 79],
  darkslategrey: [47, 79, 79],
  darkturquoise: [0, 206, 209],
  darkviolet: [148, 0, 211],
  deeppink: [255, 20, 147],
  deepskyblue: [0, 191, 255],
  dimgray: [105, 105, 105],
  dimgrey: [105, 105, 105],
  dodgerblue: [30, 144, 255],
  firebrick: [178, 34, 34],
  floralwhite: [255, 250, 240],
  forestgreen: [34, 139, 34],
  fuchsia: [255, 0, 255],
  gainsboro: [220, 220, 220],
  ghostwhite: [248, 248, 255],
  gold: [255, 215, 0],
  goldenrod: [218, 165, 32],
  gray: [128, 128, 128],
  green: [0, 128, 0],
  greenyellow: [173, 255, 47],
  grey: [128, 128, 128],
  honeydew: [240, 255, 240],
  hotpink: [255, 105, 180],
  indianred: [205, 92, 92],
  indigo: [75, 0, 130],
  ivory: [255, 255, 240],
  khaki: [240, 230, 140],
  lavender: [230, 230, 250],
  lavenderblush: [255, 240, 245],
  lawngreen: [124, 252, 0],
  lemonchiffon: [255, 250, 205],
  lightblue: [173, 216, 230],
  lightcoral: [240, 128, 128],
  lightcyan: [224, 255, 255],
  lightgoldenrodyellow: [250, 250, 210],
  lightgray: [211, 211, 211],
  lightgreen: [144, 238, 144],
  lightgrey: [211, 211, 211],
  lightpink: [255, 182, 193],
  lightsalmon: [255, 160, 122],
  lightseagreen: [32, 178, 170],
  lightskyblue: [135, 206, 250],
  lightslategray: [119, 136, 153],
  lightslategrey: [119, 136, 153],
  lightsteelblue: [176, 196, 222],
  lightyellow: [255, 255, 224],
  lime: [0, 255, 0],
  limegreen: [50, 205, 50],
  linen: [250, 240, 230],
  magenta: [255, 0, 255],
  maroon: [128, 0, 0],
  mediumaquamarine: [102, 205, 170],
  mediumblue: [0, 0, 205],
  mediumorchid: [186, 85, 211],
  mediumpurple: [147, 112, 219],
  mediumseagreen: [60, 179, 113],
  mediumslateblue: [123, 104, 238],
  mediumspringgreen: [0, 250, 154],
  mediumturquoise: [72, 209, 204],
  mediumvioletred: [199, 21, 133],
  midnightblue: [25, 25, 112],
  mintcream: [245, 255, 250],
  mistyrose: [255, 228, 225],
  moccasin: [255, 228, 181],
  navajowhite: [255, 222, 173],
  navy: [0, 0, 128],
  oldlace: [253, 245, 230],
  olive: [128, 128, 0],
  olivedrab: [107, 142, 35],
  orange: [255, 165, 0],
  orangered: [255, 69, 0],
  orchid: [218, 112, 214],
  palegoldenrod: [238, 232, 170],
  palegreen: [152, 251, 152],
  paleturquoise: [175, 238, 238],
  palevioletred: [219, 112, 147],
  papayawhip: [255, 239, 213],
  peachpuff: [255, 218, 185],
  peru: [205, 133, 63],
  pink: [255, 192, 203],
  plum: [221, 160, 221],
  powderblue: [176, 224, 230],
  purple: [128, 0, 128],
  rebeccapurple: [102, 51, 153],
  red: [255, 0, 0],
  rosybrown: [188, 143, 143],
  royalblue: [65, 105, 225],
  saddlebrown: [139, 69, 19],
  salmon: [250, 128, 114],
  sandybrown: [244, 164, 96],
  seagreen: [46, 139, 87],
  seashell: [255, 245, 238],
  sienna: [160, 82, 45],
  silver: [192, 192, 192],
  skyblue: [135, 206, 235],
  slateblue: [106, 90, 205],
  slategray: [112, 128, 144],
  slategrey: [112, 128, 144],
  snow: [255, 250, 250],
  springgreen: [0, 255, 127],
  steelblue: [70, 130, 180],
  tan: [210, 180, 140],
  teal: [0, 128, 128],
  thistle: [216, 191, 216],
  tomato: [255, 99, 71],
  turquoise: [64, 224, 208],
  violet: [238, 130, 238],
  wheat: [245, 222, 179],
  white: [255, 255, 255],
  whitesmoke: [245, 245, 245],
  yellow: [255, 255, 0],
  yellowgreen: [154, 205, 50]
}, at = { exports: {} }, Xt = function(t) {
  return !t || typeof t == "string" ? !1 : t instanceof Array || Array.isArray(t) || t.length >= 0 && (t.splice instanceof Function || Object.getOwnPropertyDescriptor(t, t.length - 1) && t.constructor.name !== "String");
}, Qt = Xt, Zt = Array.prototype.concat, er = Array.prototype.slice, Ze = at.exports = function(t) {
  for (var r = [], n = 0, a = t.length; n < a; n++) {
    var i = t[n];
    Qt(i) ? r = Zt.call(r, er.call(i)) : r.push(i);
  }
  return r;
};
Ze.wrap = function(e) {
  return function() {
    return e(Ze(arguments));
  };
};
var tr = at.exports, G = nt, X = tr, ot = Object.hasOwnProperty, st = /* @__PURE__ */ Object.create(null);
for (var ye in G)
  ot.call(G, ye) && (st[G[ye]] = ye);
var P = rt.exports = {
  to: {},
  get: {}
};
P.get = function(e) {
  var t = e.substring(0, 3).toLowerCase(), r, n;
  switch (t) {
    case "hsl":
      r = P.get.hsl(e), n = "hsl";
      break;
    case "hwb":
      r = P.get.hwb(e), n = "hwb";
      break;
    default:
      r = P.get.rgb(e), n = "rgb";
      break;
  }
  return r ? { model: n, value: r } : null;
};
P.get.rgb = function(e) {
  if (!e)
    return null;
  var t = /^#([a-f0-9]{3,4})$/i, r = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i, n = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/, a = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/, i = /^(\w+)$/, s = [0, 0, 0, 1], l, c, d;
  if (l = e.match(r)) {
    for (d = l[2], l = l[1], c = 0; c < 3; c++) {
      var g = c * 2;
      s[c] = parseInt(l.slice(g, g + 2), 16);
    }
    d && (s[3] = parseInt(d, 16) / 255);
  } else if (l = e.match(t)) {
    for (l = l[1], d = l[3], c = 0; c < 3; c++)
      s[c] = parseInt(l[c] + l[c], 16);
    d && (s[3] = parseInt(d + d, 16) / 255);
  } else if (l = e.match(n)) {
    for (c = 0; c < 3; c++)
      s[c] = parseInt(l[c + 1], 0);
    l[4] && (l[5] ? s[3] = parseFloat(l[4]) * 0.01 : s[3] = parseFloat(l[4]));
  } else if (l = e.match(a)) {
    for (c = 0; c < 3; c++)
      s[c] = Math.round(parseFloat(l[c + 1]) * 2.55);
    l[4] && (l[5] ? s[3] = parseFloat(l[4]) * 0.01 : s[3] = parseFloat(l[4]));
  } else
    return (l = e.match(i)) ? l[1] === "transparent" ? [0, 0, 0, 0] : ot.call(G, l[1]) ? (s = G[l[1]], s[3] = 1, s) : null : null;
  for (c = 0; c < 3; c++)
    s[c] = N(s[c], 0, 255);
  return s[3] = N(s[3], 0, 1), s;
};
P.get.hsl = function(e) {
  if (!e)
    return null;
  var t = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/, r = e.match(t);
  if (r) {
    var n = parseFloat(r[4]), a = (parseFloat(r[1]) % 360 + 360) % 360, i = N(parseFloat(r[2]), 0, 100), s = N(parseFloat(r[3]), 0, 100), l = N(isNaN(n) ? 1 : n, 0, 1);
    return [a, i, s, l];
  }
  return null;
};
P.get.hwb = function(e) {
  if (!e)
    return null;
  var t = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/, r = e.match(t);
  if (r) {
    var n = parseFloat(r[4]), a = (parseFloat(r[1]) % 360 + 360) % 360, i = N(parseFloat(r[2]), 0, 100), s = N(parseFloat(r[3]), 0, 100), l = N(isNaN(n) ? 1 : n, 0, 1);
    return [a, i, s, l];
  }
  return null;
};
P.to.hex = function() {
  var e = X(arguments);
  return "#" + oe(e[0]) + oe(e[1]) + oe(e[2]) + (e[3] < 1 ? oe(Math.round(e[3] * 255)) : "");
};
P.to.rgb = function() {
  var e = X(arguments);
  return e.length < 4 || e[3] === 1 ? "rgb(" + Math.round(e[0]) + ", " + Math.round(e[1]) + ", " + Math.round(e[2]) + ")" : "rgba(" + Math.round(e[0]) + ", " + Math.round(e[1]) + ", " + Math.round(e[2]) + ", " + e[3] + ")";
};
P.to.rgb.percent = function() {
  var e = X(arguments), t = Math.round(e[0] / 255 * 100), r = Math.round(e[1] / 255 * 100), n = Math.round(e[2] / 255 * 100);
  return e.length < 4 || e[3] === 1 ? "rgb(" + t + "%, " + r + "%, " + n + "%)" : "rgba(" + t + "%, " + r + "%, " + n + "%, " + e[3] + ")";
};
P.to.hsl = function() {
  var e = X(arguments);
  return e.length < 4 || e[3] === 1 ? "hsl(" + e[0] + ", " + e[1] + "%, " + e[2] + "%)" : "hsla(" + e[0] + ", " + e[1] + "%, " + e[2] + "%, " + e[3] + ")";
};
P.to.hwb = function() {
  var e = X(arguments), t = "";
  return e.length >= 4 && e[3] !== 1 && (t = ", " + e[3]), "hwb(" + e[0] + ", " + e[1] + "%, " + e[2] + "%" + t + ")";
};
P.to.keyword = function(e) {
  return st[e.slice(0, 3)];
};
function N(e, t, r) {
  return Math.min(Math.max(t, e), r);
}
function oe(e) {
  var t = Math.round(e).toString(16).toUpperCase();
  return t.length < 2 ? "0" + t : t;
}
var rr = rt.exports;
const H = nt, it = {};
for (const e of Object.keys(H))
  it[H[e]] = e;
const h = {
  rgb: { channels: 3, labels: "rgb" },
  hsl: { channels: 3, labels: "hsl" },
  hsv: { channels: 3, labels: "hsv" },
  hwb: { channels: 3, labels: "hwb" },
  cmyk: { channels: 4, labels: "cmyk" },
  xyz: { channels: 3, labels: "xyz" },
  lab: { channels: 3, labels: "lab" },
  lch: { channels: 3, labels: "lch" },
  hex: { channels: 1, labels: ["hex"] },
  keyword: { channels: 1, labels: ["keyword"] },
  ansi16: { channels: 1, labels: ["ansi16"] },
  ansi256: { channels: 1, labels: ["ansi256"] },
  hcg: { channels: 3, labels: ["h", "c", "g"] },
  apple: { channels: 3, labels: ["r16", "g16", "b16"] },
  gray: { channels: 1, labels: ["gray"] }
};
var lt = h;
for (const e of Object.keys(h)) {
  if (!("channels" in h[e]))
    throw new Error("missing channels property: " + e);
  if (!("labels" in h[e]))
    throw new Error("missing channel labels property: " + e);
  if (h[e].labels.length !== h[e].channels)
    throw new Error("channel and label counts mismatch: " + e);
  const { channels: t, labels: r } = h[e];
  delete h[e].channels, delete h[e].labels, Object.defineProperty(h[e], "channels", { value: t }), Object.defineProperty(h[e], "labels", { value: r });
}
h.rgb.hsl = function(e) {
  const t = e[0] / 255, r = e[1] / 255, n = e[2] / 255, a = Math.min(t, r, n), i = Math.max(t, r, n), s = i - a;
  let l, c;
  i === a ? l = 0 : t === i ? l = (r - n) / s : r === i ? l = 2 + (n - t) / s : n === i && (l = 4 + (t - r) / s), l = Math.min(l * 60, 360), l < 0 && (l += 360);
  const d = (a + i) / 2;
  return i === a ? c = 0 : d <= 0.5 ? c = s / (i + a) : c = s / (2 - i - a), [l, c * 100, d * 100];
};
h.rgb.hsv = function(e) {
  let t, r, n, a, i;
  const s = e[0] / 255, l = e[1] / 255, c = e[2] / 255, d = Math.max(s, l, c), g = d - Math.min(s, l, c), w = function(T) {
    return (d - T) / 6 / g + 1 / 2;
  };
  return g === 0 ? (a = 0, i = 0) : (i = g / d, t = w(s), r = w(l), n = w(c), s === d ? a = n - r : l === d ? a = 1 / 3 + t - n : c === d && (a = 2 / 3 + r - t), a < 0 ? a += 1 : a > 1 && (a -= 1)), [
    a * 360,
    i * 100,
    d * 100
  ];
};
h.rgb.hwb = function(e) {
  const t = e[0], r = e[1];
  let n = e[2];
  const a = h.rgb.hsl(e)[0], i = 1 / 255 * Math.min(t, Math.min(r, n));
  return n = 1 - 1 / 255 * Math.max(t, Math.max(r, n)), [a, i * 100, n * 100];
};
h.rgb.cmyk = function(e) {
  const t = e[0] / 255, r = e[1] / 255, n = e[2] / 255, a = Math.min(1 - t, 1 - r, 1 - n), i = (1 - t - a) / (1 - a) || 0, s = (1 - r - a) / (1 - a) || 0, l = (1 - n - a) / (1 - a) || 0;
  return [i * 100, s * 100, l * 100, a * 100];
};
function nr(e, t) {
  return (e[0] - t[0]) ** 2 + (e[1] - t[1]) ** 2 + (e[2] - t[2]) ** 2;
}
h.rgb.keyword = function(e) {
  const t = it[e];
  if (t)
    return t;
  let r = 1 / 0, n;
  for (const a of Object.keys(H)) {
    const i = H[a], s = nr(e, i);
    s < r && (r = s, n = a);
  }
  return n;
};
h.keyword.rgb = function(e) {
  return H[e];
};
h.rgb.xyz = function(e) {
  let t = e[0] / 255, r = e[1] / 255, n = e[2] / 255;
  t = t > 0.04045 ? ((t + 0.055) / 1.055) ** 2.4 : t / 12.92, r = r > 0.04045 ? ((r + 0.055) / 1.055) ** 2.4 : r / 12.92, n = n > 0.04045 ? ((n + 0.055) / 1.055) ** 2.4 : n / 12.92;
  const a = t * 0.4124 + r * 0.3576 + n * 0.1805, i = t * 0.2126 + r * 0.7152 + n * 0.0722, s = t * 0.0193 + r * 0.1192 + n * 0.9505;
  return [a * 100, i * 100, s * 100];
};
h.rgb.lab = function(e) {
  const t = h.rgb.xyz(e);
  let r = t[0], n = t[1], a = t[2];
  r /= 95.047, n /= 100, a /= 108.883, r = r > 8856e-6 ? r ** (1 / 3) : 7.787 * r + 16 / 116, n = n > 8856e-6 ? n ** (1 / 3) : 7.787 * n + 16 / 116, a = a > 8856e-6 ? a ** (1 / 3) : 7.787 * a + 16 / 116;
  const i = 116 * n - 16, s = 500 * (r - n), l = 200 * (n - a);
  return [i, s, l];
};
h.hsl.rgb = function(e) {
  const t = e[0] / 360, r = e[1] / 100, n = e[2] / 100;
  let a, i, s;
  if (r === 0)
    return s = n * 255, [s, s, s];
  n < 0.5 ? a = n * (1 + r) : a = n + r - n * r;
  const l = 2 * n - a, c = [0, 0, 0];
  for (let d = 0; d < 3; d++)
    i = t + 1 / 3 * -(d - 1), i < 0 && i++, i > 1 && i--, 6 * i < 1 ? s = l + (a - l) * 6 * i : 2 * i < 1 ? s = a : 3 * i < 2 ? s = l + (a - l) * (2 / 3 - i) * 6 : s = l, c[d] = s * 255;
  return c;
};
h.hsl.hsv = function(e) {
  const t = e[0];
  let r = e[1] / 100, n = e[2] / 100, a = r;
  const i = Math.max(n, 0.01);
  n *= 2, r *= n <= 1 ? n : 2 - n, a *= i <= 1 ? i : 2 - i;
  const s = (n + r) / 2, l = n === 0 ? 2 * a / (i + a) : 2 * r / (n + r);
  return [t, l * 100, s * 100];
};
h.hsv.rgb = function(e) {
  const t = e[0] / 60, r = e[1] / 100;
  let n = e[2] / 100;
  const a = Math.floor(t) % 6, i = t - Math.floor(t), s = 255 * n * (1 - r), l = 255 * n * (1 - r * i), c = 255 * n * (1 - r * (1 - i));
  switch (n *= 255, a) {
    case 0:
      return [n, c, s];
    case 1:
      return [l, n, s];
    case 2:
      return [s, n, c];
    case 3:
      return [s, l, n];
    case 4:
      return [c, s, n];
    case 5:
      return [n, s, l];
  }
};
h.hsv.hsl = function(e) {
  const t = e[0], r = e[1] / 100, n = e[2] / 100, a = Math.max(n, 0.01);
  let i, s;
  s = (2 - r) * n;
  const l = (2 - r) * a;
  return i = r * a, i /= l <= 1 ? l : 2 - l, i = i || 0, s /= 2, [t, i * 100, s * 100];
};
h.hwb.rgb = function(e) {
  const t = e[0] / 360;
  let r = e[1] / 100, n = e[2] / 100;
  const a = r + n;
  let i;
  a > 1 && (r /= a, n /= a);
  const s = Math.floor(6 * t), l = 1 - n;
  i = 6 * t - s, s & 1 && (i = 1 - i);
  const c = r + i * (l - r);
  let d, g, w;
  switch (s) {
    default:
    case 6:
    case 0:
      d = l, g = c, w = r;
      break;
    case 1:
      d = c, g = l, w = r;
      break;
    case 2:
      d = r, g = l, w = c;
      break;
    case 3:
      d = r, g = c, w = l;
      break;
    case 4:
      d = c, g = r, w = l;
      break;
    case 5:
      d = l, g = r, w = c;
      break;
  }
  return [d * 255, g * 255, w * 255];
};
h.cmyk.rgb = function(e) {
  const t = e[0] / 100, r = e[1] / 100, n = e[2] / 100, a = e[3] / 100, i = 1 - Math.min(1, t * (1 - a) + a), s = 1 - Math.min(1, r * (1 - a) + a), l = 1 - Math.min(1, n * (1 - a) + a);
  return [i * 255, s * 255, l * 255];
};
h.xyz.rgb = function(e) {
  const t = e[0] / 100, r = e[1] / 100, n = e[2] / 100;
  let a, i, s;
  return a = t * 3.2406 + r * -1.5372 + n * -0.4986, i = t * -0.9689 + r * 1.8758 + n * 0.0415, s = t * 0.0557 + r * -0.204 + n * 1.057, a = a > 31308e-7 ? 1.055 * a ** (1 / 2.4) - 0.055 : a * 12.92, i = i > 31308e-7 ? 1.055 * i ** (1 / 2.4) - 0.055 : i * 12.92, s = s > 31308e-7 ? 1.055 * s ** (1 / 2.4) - 0.055 : s * 12.92, a = Math.min(Math.max(0, a), 1), i = Math.min(Math.max(0, i), 1), s = Math.min(Math.max(0, s), 1), [a * 255, i * 255, s * 255];
};
h.xyz.lab = function(e) {
  let t = e[0], r = e[1], n = e[2];
  t /= 95.047, r /= 100, n /= 108.883, t = t > 8856e-6 ? t ** (1 / 3) : 7.787 * t + 16 / 116, r = r > 8856e-6 ? r ** (1 / 3) : 7.787 * r + 16 / 116, n = n > 8856e-6 ? n ** (1 / 3) : 7.787 * n + 16 / 116;
  const a = 116 * r - 16, i = 500 * (t - r), s = 200 * (r - n);
  return [a, i, s];
};
h.lab.xyz = function(e) {
  const t = e[0], r = e[1], n = e[2];
  let a, i, s;
  i = (t + 16) / 116, a = r / 500 + i, s = i - n / 200;
  const l = i ** 3, c = a ** 3, d = s ** 3;
  return i = l > 8856e-6 ? l : (i - 16 / 116) / 7.787, a = c > 8856e-6 ? c : (a - 16 / 116) / 7.787, s = d > 8856e-6 ? d : (s - 16 / 116) / 7.787, a *= 95.047, i *= 100, s *= 108.883, [a, i, s];
};
h.lab.lch = function(e) {
  const t = e[0], r = e[1], n = e[2];
  let a;
  a = Math.atan2(n, r) * 360 / 2 / Math.PI, a < 0 && (a += 360);
  const s = Math.sqrt(r * r + n * n);
  return [t, s, a];
};
h.lch.lab = function(e) {
  const t = e[0], r = e[1], a = e[2] / 360 * 2 * Math.PI, i = r * Math.cos(a), s = r * Math.sin(a);
  return [t, i, s];
};
h.rgb.ansi16 = function(e, t = null) {
  const [r, n, a] = e;
  let i = t === null ? h.rgb.hsv(e)[2] : t;
  if (i = Math.round(i / 50), i === 0)
    return 30;
  let s = 30 + (Math.round(a / 255) << 2 | Math.round(n / 255) << 1 | Math.round(r / 255));
  return i === 2 && (s += 60), s;
};
h.hsv.ansi16 = function(e) {
  return h.rgb.ansi16(h.hsv.rgb(e), e[2]);
};
h.rgb.ansi256 = function(e) {
  const t = e[0], r = e[1], n = e[2];
  return t === r && r === n ? t < 8 ? 16 : t > 248 ? 231 : Math.round((t - 8) / 247 * 24) + 232 : 16 + 36 * Math.round(t / 255 * 5) + 6 * Math.round(r / 255 * 5) + Math.round(n / 255 * 5);
};
h.ansi16.rgb = function(e) {
  let t = e % 10;
  if (t === 0 || t === 7)
    return e > 50 && (t += 3.5), t = t / 10.5 * 255, [t, t, t];
  const r = (~~(e > 50) + 1) * 0.5, n = (t & 1) * r * 255, a = (t >> 1 & 1) * r * 255, i = (t >> 2 & 1) * r * 255;
  return [n, a, i];
};
h.ansi256.rgb = function(e) {
  if (e >= 232) {
    const i = (e - 232) * 10 + 8;
    return [i, i, i];
  }
  e -= 16;
  let t;
  const r = Math.floor(e / 36) / 5 * 255, n = Math.floor((t = e % 36) / 6) / 5 * 255, a = t % 6 / 5 * 255;
  return [r, n, a];
};
h.rgb.hex = function(e) {
  const r = (((Math.round(e[0]) & 255) << 16) + ((Math.round(e[1]) & 255) << 8) + (Math.round(e[2]) & 255)).toString(16).toUpperCase();
  return "000000".substring(r.length) + r;
};
h.hex.rgb = function(e) {
  const t = e.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
  if (!t)
    return [0, 0, 0];
  let r = t[0];
  t[0].length === 3 && (r = r.split("").map((l) => l + l).join(""));
  const n = parseInt(r, 16), a = n >> 16 & 255, i = n >> 8 & 255, s = n & 255;
  return [a, i, s];
};
h.rgb.hcg = function(e) {
  const t = e[0] / 255, r = e[1] / 255, n = e[2] / 255, a = Math.max(Math.max(t, r), n), i = Math.min(Math.min(t, r), n), s = a - i;
  let l, c;
  return s < 1 ? l = i / (1 - s) : l = 0, s <= 0 ? c = 0 : a === t ? c = (r - n) / s % 6 : a === r ? c = 2 + (n - t) / s : c = 4 + (t - r) / s, c /= 6, c %= 1, [c * 360, s * 100, l * 100];
};
h.hsl.hcg = function(e) {
  const t = e[1] / 100, r = e[2] / 100, n = r < 0.5 ? 2 * t * r : 2 * t * (1 - r);
  let a = 0;
  return n < 1 && (a = (r - 0.5 * n) / (1 - n)), [e[0], n * 100, a * 100];
};
h.hsv.hcg = function(e) {
  const t = e[1] / 100, r = e[2] / 100, n = t * r;
  let a = 0;
  return n < 1 && (a = (r - n) / (1 - n)), [e[0], n * 100, a * 100];
};
h.hcg.rgb = function(e) {
  const t = e[0] / 360, r = e[1] / 100, n = e[2] / 100;
  if (r === 0)
    return [n * 255, n * 255, n * 255];
  const a = [0, 0, 0], i = t % 1 * 6, s = i % 1, l = 1 - s;
  let c = 0;
  switch (Math.floor(i)) {
    case 0:
      a[0] = 1, a[1] = s, a[2] = 0;
      break;
    case 1:
      a[0] = l, a[1] = 1, a[2] = 0;
      break;
    case 2:
      a[0] = 0, a[1] = 1, a[2] = s;
      break;
    case 3:
      a[0] = 0, a[1] = l, a[2] = 1;
      break;
    case 4:
      a[0] = s, a[1] = 0, a[2] = 1;
      break;
    default:
      a[0] = 1, a[1] = 0, a[2] = l;
  }
  return c = (1 - r) * n, [
    (r * a[0] + c) * 255,
    (r * a[1] + c) * 255,
    (r * a[2] + c) * 255
  ];
};
h.hcg.hsv = function(e) {
  const t = e[1] / 100, r = e[2] / 100, n = t + r * (1 - t);
  let a = 0;
  return n > 0 && (a = t / n), [e[0], a * 100, n * 100];
};
h.hcg.hsl = function(e) {
  const t = e[1] / 100, n = e[2] / 100 * (1 - t) + 0.5 * t;
  let a = 0;
  return n > 0 && n < 0.5 ? a = t / (2 * n) : n >= 0.5 && n < 1 && (a = t / (2 * (1 - n))), [e[0], a * 100, n * 100];
};
h.hcg.hwb = function(e) {
  const t = e[1] / 100, r = e[2] / 100, n = t + r * (1 - t);
  return [e[0], (n - t) * 100, (1 - n) * 100];
};
h.hwb.hcg = function(e) {
  const t = e[1] / 100, n = 1 - e[2] / 100, a = n - t;
  let i = 0;
  return a < 1 && (i = (n - a) / (1 - a)), [e[0], a * 100, i * 100];
};
h.apple.rgb = function(e) {
  return [e[0] / 65535 * 255, e[1] / 65535 * 255, e[2] / 65535 * 255];
};
h.rgb.apple = function(e) {
  return [e[0] / 255 * 65535, e[1] / 255 * 65535, e[2] / 255 * 65535];
};
h.gray.rgb = function(e) {
  return [e[0] / 100 * 255, e[0] / 100 * 255, e[0] / 100 * 255];
};
h.gray.hsl = function(e) {
  return [0, 0, e[0]];
};
h.gray.hsv = h.gray.hsl;
h.gray.hwb = function(e) {
  return [0, 100, e[0]];
};
h.gray.cmyk = function(e) {
  return [0, 0, 0, e[0]];
};
h.gray.lab = function(e) {
  return [e[0], 0, 0];
};
h.gray.hex = function(e) {
  const t = Math.round(e[0] / 100 * 255) & 255, n = ((t << 16) + (t << 8) + t).toString(16).toUpperCase();
  return "000000".substring(n.length) + n;
};
h.rgb.gray = function(e) {
  return [(e[0] + e[1] + e[2]) / 3 / 255 * 100];
};
const le = lt;
function ar() {
  const e = {}, t = Object.keys(le);
  for (let r = t.length, n = 0; n < r; n++)
    e[t[n]] = {
      // http://jsperf.com/1-vs-infinity
      // micro-opt, but this is simple.
      distance: -1,
      parent: null
    };
  return e;
}
function or(e) {
  const t = ar(), r = [e];
  for (t[e].distance = 0; r.length; ) {
    const n = r.pop(), a = Object.keys(le[n]);
    for (let i = a.length, s = 0; s < i; s++) {
      const l = a[s], c = t[l];
      c.distance === -1 && (c.distance = t[n].distance + 1, c.parent = n, r.unshift(l));
    }
  }
  return t;
}
function sr(e, t) {
  return function(r) {
    return t(e(r));
  };
}
function ir(e, t) {
  const r = [t[e].parent, e];
  let n = le[t[e].parent][e], a = t[e].parent;
  for (; t[a].parent; )
    r.unshift(t[a].parent), n = sr(le[t[a].parent][a], n), a = t[a].parent;
  return n.conversion = r, n;
}
var lr = function(e) {
  const t = or(e), r = {}, n = Object.keys(t);
  for (let a = n.length, i = 0; i < a; i++) {
    const s = n[i];
    t[s].parent !== null && (r[s] = ir(s, t));
  }
  return r;
};
const ke = lt, cr = lr, Y = {}, ur = Object.keys(ke);
function fr(e) {
  const t = function(...r) {
    const n = r[0];
    return n == null ? n : (n.length > 1 && (r = n), e(r));
  };
  return "conversion" in e && (t.conversion = e.conversion), t;
}
function hr(e) {
  const t = function(...r) {
    const n = r[0];
    if (n == null)
      return n;
    n.length > 1 && (r = n);
    const a = e(r);
    if (typeof a == "object")
      for (let i = a.length, s = 0; s < i; s++)
        a[s] = Math.round(a[s]);
    return a;
  };
  return "conversion" in e && (t.conversion = e.conversion), t;
}
ur.forEach((e) => {
  Y[e] = {}, Object.defineProperty(Y[e], "channels", { value: ke[e].channels }), Object.defineProperty(Y[e], "labels", { value: ke[e].labels });
  const t = cr(e);
  Object.keys(t).forEach((n) => {
    const a = t[n];
    Y[e][n] = hr(a), Y[e][n].raw = fr(a);
  });
});
var dr = Y;
const q = rr, F = dr, ct = [
  // To be honest, I don't really feel like keyword belongs in color convert, but eh.
  "keyword",
  // Gray conflicts with some method names, and has its own method defined.
  "gray",
  // Shouldn't really be in color-convert either...
  "hex"
], Ee = {};
for (const e of Object.keys(F))
  Ee[[...F[e].labels].sort().join("")] = e;
const ce = {};
function C(e, t) {
  if (!(this instanceof C))
    return new C(e, t);
  if (t && t in ct && (t = null), t && !(t in F))
    throw new Error("Unknown model: " + t);
  let r, n;
  if (e == null)
    this.model = "rgb", this.color = [0, 0, 0], this.valpha = 1;
  else if (e instanceof C)
    this.model = e.model, this.color = [...e.color], this.valpha = e.valpha;
  else if (typeof e == "string") {
    const a = q.get(e);
    if (a === null)
      throw new Error("Unable to parse color from string: " + e);
    this.model = a.model, n = F[this.model].channels, this.color = a.value.slice(0, n), this.valpha = typeof a.value[n] == "number" ? a.value[n] : 1;
  } else if (e.length > 0) {
    this.model = t || "rgb", n = F[this.model].channels;
    const a = Array.prototype.slice.call(e, 0, n);
    this.color = Re(a, n), this.valpha = typeof e[n] == "number" ? e[n] : 1;
  } else if (typeof e == "number")
    this.model = "rgb", this.color = [
      e >> 16 & 255,
      e >> 8 & 255,
      e & 255
    ], this.valpha = 1;
  else {
    this.valpha = 1;
    const a = Object.keys(e);
    "alpha" in e && (a.splice(a.indexOf("alpha"), 1), this.valpha = typeof e.alpha == "number" ? e.alpha : 0);
    const i = a.sort().join("");
    if (!(i in Ee))
      throw new Error("Unable to parse color from object: " + JSON.stringify(e));
    this.model = Ee[i];
    const { labels: s } = F[this.model], l = [];
    for (r = 0; r < s.length; r++)
      l.push(e[s[r]]);
    this.color = Re(l);
  }
  if (ce[this.model])
    for (n = F[this.model].channels, r = 0; r < n; r++) {
      const a = ce[this.model][r];
      a && (this.color[r] = a(this.color[r]));
    }
  this.valpha = Math.max(0, Math.min(1, this.valpha)), Object.freeze && Object.freeze(this);
}
C.prototype = {
  toString() {
    return this.string();
  },
  toJSON() {
    return this[this.model]();
  },
  string(e) {
    let t = this.model in q.to ? this : this.rgb();
    t = t.round(typeof e == "number" ? e : 1);
    const r = t.valpha === 1 ? t.color : [...t.color, this.valpha];
    return q.to[t.model](r);
  },
  percentString(e) {
    const t = this.rgb().round(typeof e == "number" ? e : 1), r = t.valpha === 1 ? t.color : [...t.color, this.valpha];
    return q.to.rgb.percent(r);
  },
  array() {
    return this.valpha === 1 ? [...this.color] : [...this.color, this.valpha];
  },
  object() {
    const e = {}, { channels: t } = F[this.model], { labels: r } = F[this.model];
    for (let n = 0; n < t; n++)
      e[r[n]] = this.color[n];
    return this.valpha !== 1 && (e.alpha = this.valpha), e;
  },
  unitArray() {
    const e = this.rgb().color;
    return e[0] /= 255, e[1] /= 255, e[2] /= 255, this.valpha !== 1 && e.push(this.valpha), e;
  },
  unitObject() {
    const e = this.rgb().object();
    return e.r /= 255, e.g /= 255, e.b /= 255, this.valpha !== 1 && (e.alpha = this.valpha), e;
  },
  round(e) {
    return e = Math.max(e || 0, 0), new C([...this.color.map(gr(e)), this.valpha], this.model);
  },
  alpha(e) {
    return e !== void 0 ? new C([...this.color, Math.max(0, Math.min(1, e))], this.model) : this.valpha;
  },
  // Rgb
  red: k("rgb", 0, O(255)),
  green: k("rgb", 1, O(255)),
  blue: k("rgb", 2, O(255)),
  hue: k(["hsl", "hsv", "hsl", "hwb", "hcg"], 0, (e) => (e % 360 + 360) % 360),
  saturationl: k("hsl", 1, O(100)),
  lightness: k("hsl", 2, O(100)),
  saturationv: k("hsv", 1, O(100)),
  value: k("hsv", 2, O(100)),
  chroma: k("hcg", 1, O(100)),
  gray: k("hcg", 2, O(100)),
  white: k("hwb", 1, O(100)),
  wblack: k("hwb", 2, O(100)),
  cyan: k("cmyk", 0, O(100)),
  magenta: k("cmyk", 1, O(100)),
  yellow: k("cmyk", 2, O(100)),
  black: k("cmyk", 3, O(100)),
  x: k("xyz", 0, O(95.047)),
  y: k("xyz", 1, O(100)),
  z: k("xyz", 2, O(108.833)),
  l: k("lab", 0, O(100)),
  a: k("lab", 1),
  b: k("lab", 2),
  keyword(e) {
    return e !== void 0 ? new C(e) : F[this.model].keyword(this.color);
  },
  hex(e) {
    return e !== void 0 ? new C(e) : q.to.hex(this.rgb().round().color);
  },
  hexa(e) {
    if (e !== void 0)
      return new C(e);
    const t = this.rgb().round().color;
    let r = Math.round(this.valpha * 255).toString(16).toUpperCase();
    return r.length === 1 && (r = "0" + r), q.to.hex(t) + r;
  },
  rgbNumber() {
    const e = this.rgb().color;
    return (e[0] & 255) << 16 | (e[1] & 255) << 8 | e[2] & 255;
  },
  luminosity() {
    const e = this.rgb().color, t = [];
    for (const [r, n] of e.entries()) {
      const a = n / 255;
      t[r] = a <= 0.04045 ? a / 12.92 : ((a + 0.055) / 1.055) ** 2.4;
    }
    return 0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2];
  },
  contrast(e) {
    const t = this.luminosity(), r = e.luminosity();
    return t > r ? (t + 0.05) / (r + 0.05) : (r + 0.05) / (t + 0.05);
  },
  level(e) {
    const t = this.contrast(e);
    return t >= 7 ? "AAA" : t >= 4.5 ? "AA" : "";
  },
  isDark() {
    const e = this.rgb().color;
    return (e[0] * 2126 + e[1] * 7152 + e[2] * 722) / 1e4 < 128;
  },
  isLight() {
    return !this.isDark();
  },
  negate() {
    const e = this.rgb();
    for (let t = 0; t < 3; t++)
      e.color[t] = 255 - e.color[t];
    return e;
  },
  lighten(e) {
    const t = this.hsl();
    return t.color[2] += t.color[2] * e, t;
  },
  darken(e) {
    const t = this.hsl();
    return t.color[2] -= t.color[2] * e, t;
  },
  saturate(e) {
    const t = this.hsl();
    return t.color[1] += t.color[1] * e, t;
  },
  desaturate(e) {
    const t = this.hsl();
    return t.color[1] -= t.color[1] * e, t;
  },
  whiten(e) {
    const t = this.hwb();
    return t.color[1] += t.color[1] * e, t;
  },
  blacken(e) {
    const t = this.hwb();
    return t.color[2] += t.color[2] * e, t;
  },
  grayscale() {
    const e = this.rgb().color, t = e[0] * 0.3 + e[1] * 0.59 + e[2] * 0.11;
    return C.rgb(t, t, t);
  },
  fade(e) {
    return this.alpha(this.valpha - this.valpha * e);
  },
  opaquer(e) {
    return this.alpha(this.valpha + this.valpha * e);
  },
  rotate(e) {
    const t = this.hsl();
    let r = t.color[0];
    return r = (r + e) % 360, r = r < 0 ? 360 + r : r, t.color[0] = r, t;
  },
  mix(e, t) {
    if (!e || !e.rgb)
      throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof e);
    const r = e.rgb(), n = this.rgb(), a = t === void 0 ? 0.5 : t, i = 2 * a - 1, s = r.alpha() - n.alpha(), l = ((i * s === -1 ? i : (i + s) / (1 + i * s)) + 1) / 2, c = 1 - l;
    return C.rgb(
      l * r.red() + c * n.red(),
      l * r.green() + c * n.green(),
      l * r.blue() + c * n.blue(),
      r.alpha() * a + n.alpha() * (1 - a)
    );
  }
};
for (const e of Object.keys(F)) {
  if (ct.includes(e))
    continue;
  const { channels: t } = F[e];
  C.prototype[e] = function(...r) {
    return this.model === e ? new C(this) : r.length > 0 ? new C(r, e) : new C([...vr(F[this.model][e].raw(this.color)), this.valpha], e);
  }, C[e] = function(...r) {
    let n = r[0];
    return typeof n == "number" && (n = Re(r, t)), new C(n, e);
  };
}
function pr(e, t) {
  return Number(e.toFixed(t));
}
function gr(e) {
  return function(t) {
    return pr(t, e);
  };
}
function k(e, t, r) {
  e = Array.isArray(e) ? e : [e];
  for (const n of e)
    (ce[n] || (ce[n] = []))[t] = r;
  return e = e[0], function(n) {
    let a;
    return n !== void 0 ? (r && (n = r(n)), a = this[e](), a.color[t] = n, a) : (a = this[e]().color[t], r && (a = r(a)), a);
  };
}
function O(e) {
  return function(t) {
    return Math.max(0, Math.min(e, t));
  };
}
function vr(e) {
  return Array.isArray(e) ? e : [e];
}
function Re(e, t) {
  for (let r = 0; r < t; r++)
    typeof e[r] != "number" && (e[r] = 0);
  return e;
}
var br = C;
const mr = /* @__PURE__ */ Jt(br), yr = ue.div`
  height: 30px;
  max-width: 200px;
  text-align: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    padding-right: 12px;
  }
`, xr = ({ dataAutomation: e = "logo", src: t, alt: r }) => /* @__PURE__ */ S.jsx(yr, { "data-automation": e, children: /* @__PURE__ */ S.jsx("img", { src: t, alt: r, "data-automation": `${e}-img` }) }), wr = ue.nav`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  padding-left: 20px;
  z-index: 1500;
  position: sticky;
  left: 0px;
  height: 48px;
  top: 0px;
  background: #ffffff;
  width: 100%;
  border-bottom: 1px solid #dbdbe0;

  .menu-button {
    display: none;
    width: 48px;
    height: 48px;
    svg {
      height: 28px;
      width: 28px;
    }
  }

  ${({ $hasMenuButton: e }) => e ? `
  @media only screen and (max-width: ${I.tablet}) {
    padding-left: 0px;
  }

  @media only screen and (max-width: ${I.tablet}) {
    .menu-button {
      display: flex;
    }
  }` : ""}
`, Fr = ({
  hasMenuButton: e = !0,
  dataAutomation: t = "top-nav-bar",
  "aria-label": r = "Top Navigation"
}) => {
  const { companyName: n, logo: a, handleToggleSidebar: i } = tt(Oe);
  return /* @__PURE__ */ S.jsxs(wr, { $hasMenuButton: e, "data-automation": t, "aria-label": r, children: [
    e && /* @__PURE__ */ S.jsx(
      xe,
      {
        startIcon: "Menu",
        variant: "subtle",
        className: "menu-button",
        onPress: i,
        name: "Menu",
        "aria-label": "Open menu sidebar"
      }
    ),
    a ? /* @__PURE__ */ S.jsx(xr, { src: a, alt: n || "Company logo", dataAutomation: `${t}-logo` }) : /* @__PURE__ */ S.jsx(Vt, { fontSize: "xl", fontWeight: "emphasised", children: n })
  ] });
}, kr = (e) => {
  var n;
  const [t, r] = _e(((n = globalThis == null ? void 0 : globalThis.matchMedia) == null ? void 0 : n.call(globalThis, e).matches) || !1);
  return se(() => {
    const a = () => {
      const i = window.matchMedia(e);
      r((s) => s !== i.matches ? i.matches : s);
    };
    return window.addEventListener("resize", a), () => window.removeEventListener("resize", a);
  }, [e]), t;
}, Er = Kt`
  @media only screen and (max-width: ${I.tablet}) {
    body {
      margin: 0;
      height: 100%;
      overflow: hidden;
    }
  }
`, Rr = ue.div`
  padding: 24px 8px;
  height: 100%;
  width: ${({ $isCollapse: e }) => e ? "236px" : "56px"};
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: space-between;
  background: #f6f6f7;
  z-index: 1001;
  position: sticky;
  @media only screen and (max-width: ${I.tablet}) {
    width: ${({ $isOpen: e }) => e ? "236px" : "inherit"};
    box-shadow: 0px 8px 16px rgb(31 31 35 / 12%);
  }
  @media only screen and (max-width: 1060px) {
    ${({ $isCollapse: e }) => e ? "box-shadow: 0px 8px 16px rgb(31 31 35 / 12%);" : ""};
  }
`, _r = ue.nav`
  display: inherit;
  z-index: 1001;
  position: sticky;
  top: 48px;
  left: 0px;
  height: calc(100vh - 48px);
  width: 56px;
  background: ${(e) => e.theme.colors.neutrals[100]};
  box-shadow: none;
  @media only screen and (max-width: ${I.tablet}) {
    ${({ $isOpen: e }) => e ? "position: fixed;" : ""}
  }
  .sidebar-list {
    gap: 8px;
    width: ${({ $isCollapse: e }) => e ? "220px" : "40px"};
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0;
    margin: 0;

    .space {
      margin-bottom: 24px;
    }
  }
  .sidebar-list__item {
    list-style: none;
    width: 100%;
  }

  .sidebar-link {
    width: 100%;
    line-height: 12px;
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    padding: 8px 12px;
    border: 0;
    background: none;
    box-shadow: none;
    text-align: left;
    height: 36px;
    font-size: 12px;
    line-height: 20px;
    color: ${(e) => e.theme.colors.neutrals[900]};
    font-weight: 600;
    border-radius: 6px;
    &.active {
      background-color: ${(e) => mr(e.theme.colors.text.primary).lightness(96).hex()};
      color: ${(e) => e.theme.colors.text.default} !important;
    }
    &:hover {
      background-color: ${(e) => e.theme.colors.neutrals[400]};
      color: ${(e) => e.theme.colors.neutrals[900]};
      text-decoration: none;
    }
    &:focus {
      background-color: ${(e) => e.theme.colors.neutrals[400]} !important;
      outline-offset: -1px;
      color: ${(e) => e.theme.colors.neutrals[900]}!important;
    }
    &:visited {
      color: ${(e) => e.theme.colors.neutrals[900]};
    }
    svg {
      height: 16px;
    }
  }
  .sidebar-link {
    .link-title {
      opacity: ${({ $isCollapse: e }) => e ? 1 : 0};
    }

    & > span {
      overflow-x: clip;
      line-height: 20px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .collapse-button {
    margin-bottom: 45px;
  }
  @media only screen and (max-width: ${I.tablet}) {
    width: 0;
    display: ${({ $isOpen: e }) => e ? "inherit" : "none"};

    .sidebar-link .link-title {
      opacity: ${({ $isOpen: e }) => e ? "1" : "0"};
    }
    .collapse-button {
      display: none;
    }
    .sidebar-list {
      width: 220px;
    }
  }
`, Pr = ({
  linkComponent: e,
  pathname: t = "",
  dataAutomation: r = "sidebar",
  "aria-label": n = "Side Navigation"
}) => {
  var Z;
  const [a, i] = _e(!1), s = qt(null), l = kr(`(max-width: ${I.tablet})`), { items: c, handleCloseSidebar: d, isSidebarOpen: g } = tt(Oe), w = ie(() => {
    i(($) => !$);
  }, []);
  se(() => {
    if (l && g) {
      const $ = (x) => {
        const R = x.target;
        (s.current && !s.current.contains(R) || R.classList.contains("sidebar-link")) && (d == null || d());
      };
      return document.addEventListener("mousedown", $), () => {
        document.removeEventListener("mousedown", $);
      };
    }
  }, [s, d, l, g]), se(() => {
    if (l) {
      const $ = () => {
        d == null || d();
      };
      return window.addEventListener("locationchange", $), () => {
        window.removeEventListener("locationchange", $);
      };
    }
  }, [d, l]);
  const T = ie(() => {
    g && !l && (d == null || d());
  }, [g, d, l]);
  se(() => (window.addEventListener("resize", T, !1), () => {
    window.removeEventListener("resize", T);
  }), [T]);
  const L = t || ((Z = window == null ? void 0 : window.location) == null ? void 0 : Z.pathname), Q = e || Bt;
  return /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
    /* @__PURE__ */ S.jsx(_r, { $isCollapse: a, $isOpen: g, "data-automation": r, "aria-label": n, children: /* @__PURE__ */ S.jsxs(Rr, { $isOpen: g, $isCollapse: a, ref: s, children: [
      /* @__PURE__ */ S.jsx("ul", { className: "sidebar-list", "data-automation": `${r}-list`, children: c == null ? void 0 : c.map(
        ($) => $.map((x, R) => /* @__PURE__ */ S.jsx("li", { className: `sidebar-list__item  ${R === $.length - 1 ? "space" : ""}`, children: x.onPress ? /* @__PURE__ */ S.jsx(
          xe,
          {
            "data-automation": x.id,
            id: x.id,
            startIcon: x.icon,
            className: "sidebar-link",
            onPress: x.onPress,
            name: x.title,
            children: /* @__PURE__ */ S.jsx("span", { className: "link-title", children: x.title })
          }
        ) : /* @__PURE__ */ S.jsx(
          Q,
          {
            href: x.href,
            id: x.id,
            "data-automation": x.id,
            startIcon: x.icon,
            className: `sidebar-link${x.href && new RegExp(`^${x.href}`).test(L) ? " active" : ""}`,
            title: x.title,
            children: /* @__PURE__ */ S.jsx("span", { className: "link-title", children: x.title })
          }
        ) }, x.id))
      ) }),
      /* @__PURE__ */ S.jsx(
        xe,
        {
          startIcon: a ? "DoubleCaretLeft" : "DoubleCaretRight",
          className: "sidebar-link collapse-button",
          onPress: w,
          variant: "subtle",
          name: "Toggle Navigation",
          children: "Collapse navigation"
        }
      )
    ] }) }),
    g && /* @__PURE__ */ S.jsx(Er, {})
  ] });
};
export {
  Oe as NavigationContext,
  Tr as NavigationProvider,
  Pr as Sidebar,
  Fr as TopNavBar
};
